import React, { useState, useEffect, useMemo } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const documentacionData = {
  rows: [
    { Id: 0, Valor: 'Todos' },
    { Id: 1, Valor: 'DNI' },
    { Id: 2, Valor: 'Hoja de Matricula' },
    { Id: 3, Valor: 'Fotografia carnet' },
    { Id: 4, Valor: 'C.V.' },
    { Id: 5, Valor: 'Titulo (Compulsado o revisado original)' },
    { Id: 6, Valor: 'Calificaciones compulsadas' },
    { Id: 8, Valor: 'Tarjeta Sanitaria' },
    { Id: 9, Valor: 'Número de la seguridad social' },
    { Id: 10, Valor: 'Originales' },
    { Id: 11, Valor: 'VACUNACIONES' },
    { Id: 12, Valor: 'Libro de Familia' },
    { Id: 13, Valor: 'DNI Padres/tutores' },
    { Id: 14, Valor: 'Orden SEPA' },
    { Id: 15, Valor: 'Homologación Final' },
  ],
};

const DocumentacionSelect = ({ onChangeSelected, selectedIdsString = '' }) => {
  const options = useMemo(
    () =>
      documentacionData.rows.map((item) => ({
        value: item.Id,
        label: item.Valor,
      })),
    [],
  );

  const [selectedOptions, setSelectedOptions] = useState([]);

  // 🔄 Cuando cambie selectedIdsString (prop del padre), sincronizamos el select
  useEffect(() => {
    if (selectedIdsString) {
      const idsArray = selectedIdsString.split(',').map((id) => parseInt(id, 10));
      const selected = options.filter((opt) => idsArray.includes(opt.value));
      setSelectedOptions(selected);
    } else {
      setSelectedOptions([]);
    }
  }, [selectedIdsString, options]);

  // 🔁 Cuando el usuario cambia la selección
  const handleChange = (newSelected) => {
    setSelectedOptions(newSelected || []);
    const idsString = (newSelected || []).map((opt) => opt.value).join(',');
    onChangeSelected(idsString); // enviamos al padre el string
  };

  return (
    <Select
      options={options}
      value={selectedOptions}
      isMulti
      closeMenuOnSelect={false}
      onChange={handleChange}
      placeholder="Seleccionar..."
    />
  );
};

DocumentacionSelect.propTypes = {
  onChangeSelected: PropTypes.func.isRequired,
  selectedIdsString: PropTypes.string.isRequired,
};

export default DocumentacionSelect;
